import image_1 from '../../asset/slide_1_bg.jpg';
import image_2 from '../../asset/slide_2_bg.jpg';
import image_3 from '../../asset/slide_3_bg.jpg';

export const data_carousel = [
  {
    prefix: 'Further Use Cases with XR Design Pro',
    title: 'Virtual Workforce Training',
    description: `Immerse your employees in XR-powered virtual training. Hands-on VR and AR training sessions let your team tackle real-world scenarios like equipment handling, assembly procedures, safety drills, and maintenance tasks. It's not just training – it's an experience.`,
    image: image_1,
  },
  {
    prefix: 'Further Use Cases with XR Design Pro',
    title: 'Immersive Marketing Content',
    description: `XR is the future of marketing. Create immersive, interactive, 3D content that leaves your audience spellbound. VR/AR technology allows you to create virtual showrooms and experiential campaigns that will take your brand to new heights.`,
    image: image_2,
  },
  {
    prefix: 'Further Use Cases with XR Design Pro',
    title: 'Test Ergonomics in XR',
    description: `Take the guesswork out of ergonomics with XR feasibility checks. Designers and engineers can test the comfort, safety, and efficiency of workspaces and machinery in a virtual environment. With XR, evaluate posture, reachability, fatigue levels, and the overall user experience like never before.`,
    image: image_3,
  },
];
